import { render, staticRenderFns } from "./inventoryContainer.vue?vue&type=template&id=452404f8"
import script from "./inventoryContainer.vue?vue&type=script&lang=js"
export * from "./inventoryContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports